import { MIXIN_PAGE_CREATE } from '@/mixins/page/mixinPageCreate'
import { mapGetters } from 'vuex'

export const mixinPTOPageCreateProject = {
  mixins: [MIXIN_PAGE_CREATE],
  computed: {
    ...mapGetters('pto/project', {
      dataAdd: 'getChildrenFilter'
    })
  },
  methods: {
    async createPtoProjectHandler (data) {
      await this.sendPostRequest({
        ...data,
        ...this.dataAdd
      })
    }
  }
}
